<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- CONTENT HEADER -->
    <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="mr-16" [routerLink]="'/companies'" (click)="reiniciaVariables()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="m-0">{{'AVANCES.REGRESAR' | translate}}</h2>
    </div>
    <!-- / CONTENT HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card" class="center " fxLayout="row wrap">
      <!-- CONTENT -->
      <div style="margin: 20px;" fxFlex="100" fxLayout="row" fxLayoutAlign="start stretch">

        <mat-sidenav-container fxFlex="100">
          <mat-sidenav #sidenav mode="side" [(opened)]="show">
            <div fxLayout="row" fxLayoutAlign="center stretch" class="">
              <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch">
                <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'AVANCES.ENCUESTA.PRODUCTS' | translate}}</h2>
                  <button mat-icon-button (click)="sidenav.toggle()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <mat-divider></mat-divider>
                <div class="" fxLayout="row" fxLayoutAlign="start stretch" *ngIf="cargaCompleta">
                  <ul id="menutree">
                    <ng-container *ngIf="arrayCertificar.length > 0">
                      <li class="collapse" style="padding-top: 5px;">
                        <!--<input type="checkbox" id="m1" />-->

                        <input type="checkbox" id="m1" checked *ngIf="m1_check" />
                        <input type="checkbox" id="m1" *ngIf="!m1_check" />
                        <label for="m1" id="m1_check">
                          {{'NAV.CERTIFICAR.TITULO' | translate}}
                        </label>
                        <ul>
                          <li *ngFor="let cert of arrayCertificar; let k = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{k}}">
                            <p id="myProduct" class="" (click)="obtenerData(cert.nombreProducto,cert.fechaCertificar, cert.idCertificar,k,cert.idSurvey,'','','Certificar','NAV.CERTIFICAR.TITULO',cert.tokenConfig,cert.tipo,cert.plantilla,cert.idProducto)" [ngClass]="{'Selected_product': cert.idCertificar == idProducto_tmp }">
                              {{'NAV.CERTIFICAR.TITULO' | translate}} {{cert.fechaCertificar}}
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="arrayCertificar3.length > 0">
                      <li class="collapse" style="padding-top: 5px;">
                        <!--<input type="checkbox" id="m1" />-->

                        <input type="checkbox" id="cer3" checked *ngIf="cer3_check" />
                        <input type="checkbox" id="cer3" *ngIf="!cer3_check" />
                        <label for="cer3" id="cer3_check">
                          {{'NAV.CERTIFICAR.TITULO' | translate}} 3.0
                        </label>
                        <ul>
                          <li *ngFor="let cert of arrayCertificar3; let k = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{k}}">
                            <p id="myProduct" class="" (click)="obtenerData(cert.nombreProducto,cert.fechaCertificar, cert.idCertificar,k,cert.idSurvey,'','','Certificar','NAV.CERTIFICAR.SUBPRODUCTOS.3',cert.tokenConfig,cert.tipo,cert.plantilla,cert.idProducto)" [ngClass]="{'Selected_product': cert.idCertificar == idProducto_tmp }">
                              {{'NAV.CERTIFICAR.TITULO' | translate}} {{cert.fechaCertificar}}
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ng-container>

                    <ng-container *ngIf="arrayMedir3.length > 0">
                      <li class="collapse" style="padding-top: 5px;">
                        <!--<input type="checkbox" id="m1" />-->

                        <input type="checkbox" id="m13" checked *ngIf="m13_check" />
                        <input type="checkbox" id="m13" *ngIf="!m13_check" />
                        <label for="m13" id="m13_check">
                          {{'NAV.MEDIR.TITULO' | translate}} 3.0
                        </label>
                        <ul>
                          <li *ngFor="let cert of arrayMedir3; let m = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{m}}">
                            <p id="myProduct" class="" (click)="obtenerData(cert.nombreProducto,cert.fechaCertificar, cert.idCertificar,m,cert.idSurvey,'','','Certificar','NAV.MEDIR.SUBPRODUCTOS.7',cert.tokenConfig,cert.tipo,cert.plantilla,cert.idProducto)" [ngClass]="{'Selected_product': cert.idCertificar == idProducto_tmp }">
                              {{'NAV.MEDIR.TITULO' | translate}} {{cert.fechaCertificar}}
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ng-container>

                    <ng-container *ngIf="arrayPulse3.length > 0">
                      <li class="collapse" style="padding-top: 5px;">
                        <!--<input type="checkbox" id="m1" />-->

                        <input type="checkbox" id="p1" checked *ngIf="p1_check" />
                        <input type="checkbox" id="p1" *ngIf="!p1_check" />
                        <label for="p1" id="p1_check">
                          {{'NAV.PULSE.TITULO' | translate}} 3.0
                        </label>
                        <ul>
                          <li *ngFor="let cert of arrayPulse3; let m = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{m}}">
                            <p id="myProduct" class="" (click)="obtenerData(cert.nombreProducto,cert.fechaCertificar, cert.idCertificar,m,cert.idSurvey,'','','Certificar','NAV.PULSE.SUBPRODUCTOS.1',cert.tokenConfig,cert.tipo,cert.plantilla,cert.idProducto)" [ngClass]="{'Selected_product': cert.idCertificar == idProducto_tmp }">
                              {{'NAV.PULSE.TITULO' | translate}} {{cert.fechaCertificar}}
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ng-container>

                    <ng-container *ngIf="arrayMedir.length > 0 || arrayMedirGenerico.length > 0">
                      <li class="collapse" style="padding-top: 5px;">
                        <input type="checkbox" id="m2" checked *ngIf="medir_checked" />
                        <input type="checkbox" id="m2" *ngIf="!medir_checked" />
                        <label for="m2">
                          {{'NAV.MEDIR.TITULO' | translate}}
                        </label>
                        <ul>
                          <ng-container *ngIf="arrayMedir.length > 0">
                            <li *ngFor="let cert of arrayMedir; let k = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{k}}">
                              <p class="" (click)="obtenerData('NAV.MEDIR.SUBPRODUCTOS.0',cert.fechaMedir, cert.idMedir,k,cert.idSurvey,'','','Medir','NAV.MEDIR.SUBPRODUCTOS.0',cert.tokenConfig,2,cert.plantilla)" [ngClass]="{'Selected_product': cert.idMedir == idProducto_tmp }"> {{'NAV.MEDIR.SUBPRODUCTOS.0' | translate}} {{cert.fechaMedir}} </p>
                            </li>
                          </ng-container>
                          <ng-container *ngIf="arrayMedirGenerico.length > 0">
                            <li *ngFor="let cert of arrayMedirGenerico; let k = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{k}}">
                              <p class="" (click)="obtenerData('NAV.MEDIR.SUBPRODUCTOS.1',cert.fechaProducto, cert.idProducto,k,cert.idSurvey,'','','Medir mejorador','NAV.MEDIR.SUBPRODUCTOS.1',cert.tokenConfig,3,cert.plantilla)" *ngIf="cert.tipo == 1" [ngClass]="{'Selected_product': cert.idProducto == idProducto_tmp }">
                                {{'NAV.MEDIR.SUBPRODUCTOS.1' | translate}} {{cert.fechaProducto}} </p>
                                <p class="" (click)="obtenerData('NAV.MEDIR.SUBPRODUCTOS.2',cert.fechaProducto, cert.idProducto,k,cert.idSurvey,'','','Medir MTS','NAV.MEDIR.SUBPRODUCTOS.2',cert.tokenConfig,3,cert.plantilla)" *ngIf="cert.tipo == 2" [ngClass]="{'Selected_product': cert.idProducto == idProducto_tmp }">
                                  {{'NAV.MEDIR.SUBPRODUCTOS.2' | translate}} {{cert.fechaProducto}} </p>
                                  <p class="" (click)="obtenerData('NAV.MEDIR.SUBPRODUCTOS.3',cert.fechaProducto, cert.idProducto,k,cert.idSurvey,'','','Medir áreas','NAV.MEDIR.SUBPRODUCTOS.3',cert.tokenConfig,3,cert.plantilla)" *ngIf="cert.tipo == 3" [ngClass]="{'Selected_product': cert.idProducto == idProducto_tmp }">
                                    {{'NAV.MEDIR.SUBPRODUCTOS.3' | translate}} {{cert.fechaProducto}} </p>
                                    <p class="" (click)="obtenerData('NAV.MEDIR.SUBPRODUCTOS.4',cert.fechaProducto, cert.idProducto,k,cert.idSurvey,'','','Medir líderes','NAV.MEDIR.SUBPRODUCTOS.4',cert.tokenConfig,3,cert.plantilla)" *ngIf="cert.tipo == 4" [ngClass]="{'Selected_product': cert.idProducto == idProducto_tmp }">
                                      {{'NAV.MEDIR.SUBPRODUCTOS.4' | translate}} {{cert.fechaProducto}} </p>
                                      <p class="" (click)="obtenerData('NAV.MEDIR.SUBPRODUCTOS.5',cert.fechaProducto, cert.idProducto,k,cert.idSurvey,'','','Medir dimencione','NAV.MEDIR.SUBPRODUCTOS.5',cert.tokenConfig,3,cert.plantilla)" *ngIf="cert.tipo == 5" [ngClass]="{'Selected_product': cert.idProducto == idProducto_tmp }">
                                        {{'NAV.MEDIR.SUBPRODUCTOS.5' | translate}} {{cert.fechaProducto}} </p>
                                        <p class="" (click)="obtenerData('NAV.MEDIR.SUBPRODUCTOS.6',cert.fechaProducto, cert.idProducto,k,cert.idSurvey,'','','Medir certificar','NAV.MEDIR.SUBPRODUCTOS.6',cert.tokenConfig,3,cert.plantilla)" *ngIf="cert.tipo == 6" [ngClass]="{'Selected_product': cert.idProducto == idProducto_tmp }">
                                          {{'NAV.MEDIR.SUBPRODUCTOS.6' | translate}} {{cert.fechaProducto}} </p>
                                        </li>
                                      </ng-container>
                                    </ul>
                                  </li>
                    </ng-container>


                    <ng-container *ngIf="arrayPulse.length > 0">
                                  <li class="collapse" style="padding-top: 5px;">
                                    <input type="checkbox" id="m3" checked *ngIf="pulse_checked" />
                                    <input type="checkbox" id="m3" *ngIf="!pulse_checked" />
                                    <label for="m3">
                                      {{'NAV.PULSE.TITULO' | translate}}
                                    </label>
                                    <ul>
                                      <li *ngFor="let cert of arrayPulse; let k = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{k}}">
                                        <p class="" (click)="obtenerData('NAV.PULSE.TITULO',cert.fechaPulseCheck, cert.idPulseCheck,k,cert.idSurvey,'','','Pulse check','NAV.PULSE.TITULO',cert.tokenConfig,'4','NAV.PULSE.TITULO')" [ngClass]="{'Selected_product': cert.idPulseCheck == idProducto_tmp }">
                                          {{'NAV.PULSE.TITULO' | translate}} {{cert.fechaPulseCheck}} </p>
                                        </li>
                                      </ul>
                                    </li>
                    </ng-container>

                    <ng-container *ngIf="aniosFocusAgregados.length > 0">
                          <li class="collapse" style="padding-top: 5px;">
                            <input type="checkbox" id="m7" />
                            <label for="m7">
                              {{'NAV.FOCUS.TITULO' | translate}}
                            </label>
                            <ul id="menutree" style="margin-top:20px">
                              <li class="collapse" style="padding-top: 5px;" *ngFor="let cert of aniosFocusAgregados;">
                                <input type="checkbox" id="r77eq9" />
                                <label for="r77eq9">
                                  {{'NAV.FOCUS.TITULO' | translate}} {{cert.fecha}}
                                </label>
                                <ul >
                                  <li *ngFor="let certFocus of cert.datos; let k = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{k}}">
                                    <p id="myProduct" class="" (click)="obtenerData(certFocus.nombreProducto,certFocus.fechaCertificar, certFocus.idCertificar,k,certFocus.idSurvey,'','','FocusArea','NAV.FOCUS.TITULO',certFocus.tokenConfig,certFocus.tipo,certFocus.plantilla,certFocus.idProducto)" [ngClass]="{'Selected_product': certFocus.idCertificar == idProducto_tmp }">
                                      {{certFocus.nameSurvey}}
                                    </p>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                    </ng-container>

                    <ng-container *ngIf="arrayNorma.length > 0">
                        <li class="collapse" style="padding-top: 5px;">
                          <input type="checkbox" id="m5" />
                          <label for="m5">
                            {{'NAV.NORMA35.TITULO' | translate}}
                          </label>
                          <ul>
                            <li *ngFor="let cert of arrayNorma; let k = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{k}}">
                              <p class="" (click)="obtenerData('NAV.NORMA35.TITULO',cert.fechaNorma35, cert.idNorma35,k,'',cert.idSurveyMenos,cert.idSurveyMas,'Nom035','NAV.NORMA35.TITULO')" [ngClass]="{'Selected_product': cert.idNorma35 == idProducto_tmp }"> {{'NAV.NORMA35.TITULO' | translate}} {{cert.fechaNorma35}} </p>
                            </li>
                          </ul>
                        </li>
                    </ng-container>

                    <ng-container *ngIf="arrayCulturalGoExpress.length > 0">
                      <li class="collapse" style="padding-top: 5px;">
                        <!--<input type="checkbox" id="m1" />-->

                        <input type="checkbox" id="express3" checked *ngIf="cer3_check" />
                        <input type="checkbox" id="express3" *ngIf="!express3_check" />
                        <label for="express3" id="express3_check">
                          Cultural Go Express
                        </label>
                        <ul>
                          <li *ngFor="let goExpress of arrayCulturalGoExpress; let expre = index" [ngClass]="{'seleccionado': currentStep > 0}" id="step{{expre}}">
                            <!-- <p id="myProductExpre" class=""> -->
                            <p id="myProductExpre" class="" (click)="obtenerData('express',goExpress.date, goExpress._id,expre,goExpress.idSurvey,'','','goExpress','NAV.CERTIFICAR.SUBPRODUCTOS.3',goExpress.surveyToken,'tipoExpress',0,goExpress.idProduct)" [ngClass]="{'Selected_product': goExpress._id == idProducto_tmp }">
                              Cultural Go Express {{goExpress.date}}
                              <!-- {{'NAV.CERTIFICAR.TITULO' | translate}} {{goExpress.date}} -->
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ng-container>
                    </ul>
                  </div>
                </div>
              </div>
            </mat-sidenav>

            <mat-sidenav-content>
              <!--Visualización de acciones -->
              <div fxLayout="row" class="example-sidenav-content" style="padding-top: 0px; " fxLayoutAlign="center stretch" fxFlex="100">

                <ng-container *ngIf="!mostrarSeccion">
                  <div class="course-step-content p-20 container1" fxFlex="100">
                    <div fxLayout="column" fxLayoutAlign="start center">
                      <button mat-mini-fab color="accent" *ngIf="!show" (click)="sidenav.toggle()" class="botonInfo" matTooltipPosition="right">
                        <mat-icon>info</mat-icon>
                      </button>
                      <h1>{{'AVANCES.INICIO.TITULO' | translate}}</h1>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="space-around stretch" style="width: 100%;">
                      <h4>{{'AVANCES.INICIO.INSTRUCCIONES' | translate}}</h4>
                    </div>

                  </div>
                </ng-container>
                <ng-container *ngIf="mostrarSeccion">
                  <div class="course-step-content p-20" fxFlex="100">
                    <ng-container *ngIf="!cargando">
                      <div fxLayout="column" fxLayoutAlign="start center" style="padding-top: 5%; margin-top: 15%;">
                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                        <h1>{{'AVANCES.ENCUESTA.CARGANDO' | translate}} </h1>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="cargando && !activeSurvey && !noEncuesta">
                      <div class="mat-elevation-z4 pr-20 pl-20" fxLayout="row" style="margin-top: 10%; width: 80%;" fxLayoutAlign="center center">
                        <h2> {{'AVANCES.ENCUESTA.ACTIVA' | translate}} </h2>
                        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="cargando && noEncuesta ">
                      <div class="mat-elevation-z4 pr-20 pl-20" fxLayout="row" style="margin-top: 10%; width: 80%;" fxLayoutAlign="center center">
                        <h2>{{'AVANCES.ENCUESTA.ERROR' | translate}}</h2>
                        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="cargando && !noEncuesta && activeSurvey">
                      <div class="" fxLayout="column" fxLayoutAlign="start center">
                        <h1>{{nombreEmpresa}}</h1>
                        <button mat-mini-fab color="accent" *ngIf="!show" (click)="sidenav.toggle()" class="botonInfo" matTooltipPosition="right">
                          <mat-icon>info</mat-icon>
                        </button>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="space-around stretch" style="width: 100%;">

                        <h4><span style="font-weight: 900">{{'AVANCES.PRODUCTO' | translate}}:</span> {{nombreSecundario | translate}}</h4>
                        <h4 *ngIf="!disableButton"><span style="font-weight: 900">{{'AVANCES.FEC-LAN' | translate}}:</span> {{fechaLanzamiento | date:"d MMM y H:mm":offsetPipe:idiomaActual}} ( {{cityname | translate}} {{fechaLanzamiento |date:'O':offsetPipe:idiomaActual}})</h4>
                        <h4 *ngIf="disableButton"><span style="font-weight: 900">{{'AVANCES.FEC-LAN' | translate}}:</span> {{'AVANCES.NOFEC-LAN' | translate}} </h4>
                        <h4 *ngIf="!sinProrrogas && !disableButton"><span style="font-weight: 900">{{'AVANCES.FEC-CIE' | translate}}:</span> {{fechaCierre | date:"d MMM y H:mm":offsetPipe:idiomaActual}} ( {{cityname | translate}} {{fechaCierre |date:'O':offsetPipe:idiomaActual}})</h4>
                        <h4 *ngIf="sinProrrogas"><span style="font-weight: 900">{{'AVANCES.FEC-CIE-PROR' | translate}}:</span> {{prorrogasGuardas | date:"d MMM y H:mm":offsetPipe:idiomaActual}} ( {{cityname | translate}} {{prorrogasGuardas |date:'O':offsetPipe:idiomaActual}})</h4>
                      </div>

                      <div fxLayout="column" fxLayoutAlign="end center" style="width: 100%;" *ngIf="!hasNorma  && fechaLanzamiento">
                        <h3 style="font-weight: bolder;"> {{'AVANCES.PORCENTAJE' | translate}} <span>{{porcentaje.toFixed(2)}}%</span></h3>
                      </div>
                      <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%;" *ngIf="!hasNorma &&  fechaLanzamiento">
                        <div class="" fxLayout="row" fxLayoutAlign="center start" style="width: 90%;">
                          <mat-progress-bar mode="determinate" value="{{ porcentaje }}" style="height:15px"></mat-progress-bar>
                          <h4 style="margin-left:30px;font-weight:900" *ngIf="!hasFocus">{{diasRestantes}} {{'CIERRE.LABEL9' | translate}}</h4>
                        </div>
                      </div>
                      <ng-container *ngIf="hasNorma && fechaLanzamiento">
                        <h4 style="margin-left:30px;font-weight:900" *ngIf="!hasFocus">{{diasRestantes}} {{'CIERRE.LABEL9' | translate}}</h4>
                        <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%;" *ngIf="hasNorma &&  fechaLanzamiento && menos50">
                          <div class="" fxLayout="row" fxLayoutAlign="center start" style="width: 90%;">
                            <mat-progress-bar mode="determinate" value="{{ porcentaje2 }}" style="height:15px"></mat-progress-bar>

                          </div>
                          <div class="" fxLayout="row" fxLayoutAlign="center start" style="width: 90%;">
                            <h4 style="font-weight:900">{{ porcentaje2 }}%</h4>
                          </div>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%;" *ngIf="hasNorma &&  fechaLanzamiento && mas50">
                          <div class="" fxLayout="row" fxLayoutAlign="center start" style="width: 90%;">
                            <mat-progress-bar mode="determinate" value="{{ porcentaje1 }}" style="height:15px"></mat-progress-bar>
                          </div>
                          <div class="" fxLayout="row" fxLayoutAlign="center start" style="width: 90%;">
                            <h4 style="font-weight:900">{{ porcentaje1 }}%</h4>
                          </div>
                        </div>
                      </ng-container>




                      <div fxLayout="row" fxLayoutAlign="start start">
                        <ng-container *ngIf="permisoProrroga">

                          <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px; font-weight:bolder; margin-top: 8px;">
                            {{'AVANCES.SURVEY' | translate}}
                          </div>
                          <ng-container *ngIf="!btnProrroga && statusEncuesta==1">

                            <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px; ;">
                              <button mat-raised-button class="mb-20" style="backgroung-color:#A2A3A8;" (click)="modalBtnCerrarProrro()">
                                {{'AVANCES.CER' | translate}}
                                <mat-icon class="ml-20">power_settings_new</mat-icon>
                              </button>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="btnProrroga && statusEncuesta==1">
                            <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px; ;">
                              <button mat-raised-button class="mb-20" color="primary" (click)="actualizaCerrarEncuesta(2)">
                                <!-- <button mat-raised-button class="mb-20" color="primary" (click)="actualizaCerrarEncuesta(2)" [disabled]="encuesta_cerrada"> -->
                                {{'AVANCES.CER' | translate}}
                                <mat-icon class="ml-20">power_settings_new</mat-icon>
                              </button>
                            </div>

                          </ng-container>
                          <ng-container *ngIf="statusEncuesta==2">
                            <div fxLayout="row" fxLayoutAlign="space-between start start" style="padding-right: 5px;">
                              <button mat-raised-button class="mb-20" style="backgroung-color:#A2A3A8;" (click)="actualizaCerrarEncuesta(1)">
                                <!-- <button mat-raised-button class="mb-20" style="backgroung-color:#A2A3A8;" (click)="cierreEncuestaStatus2()"> -->
                                {{'AVANCES.ABR' | translate}}
                                <mat-icon class="ml-20">power_settings_new</mat-icon>
                              </button>
                            </div>
                          </ng-container>




                          <ng-container *ngIf="!btnProrroga">
                            <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px;">
                              <button mat-raised-button class="mb-20" style="backgroung-color:#A2A3A8;" (click)="modalBtnCerrarProrro()">
                                {{'AVANCES.PROR' | translate}}
                                <mat-icon class="ml-20">calendar_today</mat-icon>
                              </button>
                            </div>

                          </ng-container>


                          <ng-container *ngIf="btnProrroga">
                            <div fxLayout="row" fxLayoutAlign="space-between end">
                              <button mat-raised-button class="mb-20" color="primary" (click)="fechaGenerica.open()">
                                {{'AVANCES.PROR' | translate}}
                                <mat-icon class="ml-20">calendar_today</mat-icon>
                              </button>
                            </div>



                            <!-- <input *ngIf="sinProrrogas" matInput #inputFecha [matDatepicker]="fechaGenerica" [matDatepickerFilter]="filtroCierreProrroga" (dateChange)="fechaSeleccionada($event)"> -->
                            <mat-form-field class="calHid">
                              <input matInput #inputFecha [matDatepicker]="fechaGenerica" [matDatepickerFilter]="filtroLanzamiento" (dateChange)="fechaSeleccionada($event)" [(ngModel)]="fechaValueProrroga">
                              <mat-datepicker touchUi #fechaGenerica></mat-datepicker>
                            </mat-form-field>
                            <div class="calHid">
                              <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" [min]="filtroHoraHoy" (opened)="horaAbierta($event)" id="timepicker" [value]="'23:59'" readonly>
                              <ngx-material-timepicker [enableKeyboardInput]="true" (timeSet)="horaSeleccionada($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
                              <ng-template #cancelBtn>
                                <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
                              </ng-template>
                              <ng-template #confirmBtn>
                                <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
                              </ng-template>
                              <ng-template #dialHint>
                                <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{fechaProrroga | date:"d MMM y":offsetPipe:idiomaActual}}</b>
                              </ng-template>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="!hasNorma">
                            <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px;">
                              <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'AVANCES.GOPORTAL' | translate}}" [routerLink]="'/portalControl/'">
                                {{'AVANCES.GOPORTAL' | translate}}
                                <mat-icon>vpn_key</mat-icon>
                              </button>
                            </div>

                          </ng-container>
                          <ng-container *ngIf="!mostrarBtnCopyEnl && !hasNorma">
                              <button mat-raised-button class="mb-20" (click)="generarClave()">
                    {{'CIERRE.CIERRE.BACCESO' | translate}}
                    <mat-icon>vpn_key</mat-icon>
                  </button>
                          </ng-container>
                          <ng-container *ngIf="mostrarBtnCopyEnl && !hasNorma">
                              <button mat-raised-button class="mb-20" (click)="copyMessageUrlCon(claveConteos)" value="click to copy" color="primary">
                    {{'CIERRE.CIERRE.LINKPORTAL' | translate}}
                    <mat-icon>vpn_key</mat-icon>
                  </button>
                          </ng-container>
                          <ng-container *ngIf="hasNorma && menos50">
                            <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px;">
                              <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'AVANCES.GOPORTAL' | translate}}" (click)="typeSurvey(1)" [routerLink]="'/portalControl/'" style="padding-right: 7px !important;">
                                {{'AVANCES.GOPORTAL' | translate}} - 50
                                <mat-icon>vpn_key</mat-icon>
                              </button>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="hasNorma && mas50">
                            <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px;">
                              <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'AVANCES.GOPORTAL' | translate}}" (click)="typeSurvey(2)" [routerLink]="'/portalControl/'" style="padding-left: 10px !important;">
                                {{'AVANCES.GOPORTAL' | translate}} + 50
                                <mat-icon>vpn_key</mat-icon>
                              </button>
                            </div>
                          </ng-container>



                          <mat-form-field class="calHid">
                            <input matInput #inputFecha [matDatepicker]="fechaGenerica" [matDatepickerFilter]="filtroLanzamiento" (dateChange)="fechaSeleccionada($event)" [(ngModel)]="fechaValueProrroga">
                            <mat-datepicker touchUi #fechaGenerica></mat-datepicker>
                          </mat-form-field>
                          <div class="calHid">
                            <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" [min]="filtroHoraHoy" (opened)="horaAbierta($event)" id="timepicker" [value]="'23:59'" readonly>
                            <ngx-material-timepicker [enableKeyboardInput]="true" (timeSet)="horaSeleccionada($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
                            <ng-template #cancelBtn>
                              <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
                            </ng-template>
                            <ng-template #confirmBtn>
                              <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
                            </ng-template>
                            <ng-template #dialHint>
                              <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{fechaProrroga | date:"d MMM y":offsetPipe:idiomaActual}}</b>
                            </ng-template>
                          </div>
                        </ng-container>

                      </div>
                      <div fxLayout="row" fxLayoutAlign="start start">
                        <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 2px; font-weight:bolder; margin-top: 8px;">
                          {{'AVANCES.FILE' | translate}}
                        </div>
                        <ng-container>
                          <div fxLayout="row" fxLayoutAlign="space-between end" style="padding-right: 5px; ">
                            <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'CONSULTATABLA.FILEMAN_PRIV' | translate}}" (click)="verCloud()">
                              {{'CONSULTATABLA.FILEMAN_PRIV' | translate}}
                              <mat-icon>folder</mat-icon>
                            </button>
                          </div>
                        </ng-container>
                        <ng-container>
                          <div fxLayout="row" fxLayoutAlign="space-between end">
                            <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'CONSULTATABLA.FILEMAN_PUB' | translate}}" (click)="verCloudPublico()">
                              {{'CONSULTATABLA.FILEMAN_PUB' | translate}}
                              <mat-icon>folder_shared</mat-icon>
                            </button>
                          </div>
                        </ng-container>

                      </div>


                      <div fxLayout="row" fxLayoutAlign="start start" style="width: 100%;">
                        <mat-expansion-panel style="width: 100%!important;">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              {{'AVANCES.ENCUESTA.ACTIONS' | translate}}
                            </mat-panel-title>
                            <mat-panel-description>
                              {{'AVANCES.DES' | translate}}

                              <mat-icon>settings_applications</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>


                          <div fxLayout="column" fxLayoutAlign="start start">
                            <div fxFlex="100" fxLayout="row" fxLayoutAlign="start center">
                              <mat-list role="list">
                                <mat-list-item role="listitem">
                                  <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'AVANCES.SINCRONIZAR' | translate}}" (click)="sincronizarPortalConteos()" style="width: 100%">
                                    {{'AVANCES.SINCRONIZAR' | translate}}
                                    <mat-icon>vibration</mat-icon>
                                  </button>
                                </mat-list-item>
                                <mat-list-item role="listitem">
                                  <button mat-raised-button color="primary" matTooltip="{{'AVANCES.AGREGAR' | translate}}" (click)="openDialogSurvey()" style="width: 100%" [disabled]="encuesta_cerrada ">
                                    {{'AVANCES.AGREGAR' | translate}}
                                    <mat-icon>person_add_alt_1</mat-icon>
                                  </button>
                                </mat-list-item>
                                <mat-list-item role="listitem">
                                  <button mat-raised-button color="primary" matTooltip="{{'SHEDULE2_0.CARDS.PASO5.TITULO' | translate}}" (click)="surveyCheckService()" style="width: 100%;">
                                    {{'SHEDULE2_0.CARDS.PASO5.TITULO' | translate}}
                                    <mat-icon>check_circle</mat-icon>
                                  </button>
                                </mat-list-item>

                                <mat-list-item role="listitem">
                                  <!--*ngIf="nombreProducto == 'Certify' || showMedir" -->
                                  <!-- <ng-container *ngIf="!btnRecordatoriosProd3">
                                    <button  mat-raised-button color="primary" matTooltip="{{'CIERRE.CIERRE.REMANDER' | translate}}" (click)="Reminder()" style="width: 100%;" [disabled]="encuesta_cerrada || bloquearBotonReminder">
                                      {{'CIERRE.CIERRE.REMANDERC2' | translate}}
                                      <mat-icon>email</mat-icon>
                                    </button>

                                  </ng-container> -->
                                  <!-- <ng-container *ngIf="btnRecordatoriosProd3"> -->
                                    <button  mat-raised-button color="primary" matTooltip="{{'CIERRE.CIERRE.REMANDER' | translate}}" (click)="Reminder()" style="width: 100%;" [disabled]="encuesta_cerrada || bloquearBotonReminder">
                                      {{'CIERRE.CIERRE.REMANDER' | translate}}
                                      <mat-icon>email</mat-icon>
                                    </button>

                                  <!-- </ng-container> -->
                                </mat-list-item>

                                <mat-list-item role="listitem">
                                  <!--*ngIf="nombreProducto == 'Certify' || showMedir" -->
                                  <button mat-raised-button color="primary" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" (click)="DialogDescargar_encuesta()" style="width: 100%;">
                                    {{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}
                                    <mat-icon>arrow_downward</mat-icon>
                                  </button>
                                </mat-list-item>

                                <mat-list-item role="listitem">
                                  <button mat-raised-button color="primary" (click)="descargaExcelColaboradores()" style="width: 100%;">
                                    {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.DESCARGA' | translate}}
                                    <mat-icon class="ml-20">cloud_download</mat-icon>
                                  </button>
                                </mat-list-item>

                                <mat-list-item role="listitem">
                                  <button mat-raised-button color="primary" (click)="cierreManual()" style="width: 100%;">
                                    {{'AVANCES.PROCESARRESU' | translate}}
                                    <mat-icon class="ml-20">settings</mat-icon>
                                  </button>
                                </mat-list-item>
                              </mat-list>
                            </div>
                          </div>
                          <div fxLayout="column" fxLayoutAlign="space-around start"></div>

                        </mat-expansion-panel>
                      </div>

                      <div fxLayout="column" fxLayoutAlign="space-around stretch" style="width: 100%; padding-top: 5%;">
                        <div>
                          <div fxFlex="50" fxLayout="row" fxLayoutAlign="start center">
                            <mat-form-field appearance="outline" fxFlex>
                              <mat-label>{{'AVANCES.ENCUESTA.PLACE' | translate}}</mat-label>
                              <!--ng-keydown="obtenerUser($event.target.value)" ng-keypress="obtenerUser($event.target.value)" (blur)="obtenerUser($event.target.value);"-->
                              <input matInput [(ngModel)]='busqueda' (keydown.enter)="obtenerUser($event.target.value)">
                              <!--<mat-icon matSuffix class="disabled-text">search</mat-icon>-->
                            </mat-form-field>
                          </div>
                          <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" style="padding-left: 3%!important;">
                            <!--<input onkeyup="onKeyUp(event)" type="text" id="txtConvBusFch" class="form-control datepicker" placeholder="Desde Fecha">-->
                            <button mat-mini-fab color="primary" aria-label="Example icon button with a menu icon" (click)="obtenerUser()" matTooltip="{{'AVANCES.ENCUESTA.BUSCAR' | translate}}">
                              <mat-icon>search</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div fxLayout="row" fxLayoutAlign="start start">
                        <div fxLayout="row" fxLayoutAlign="space-between start start" style="padding-right: 5px;">
                          <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'AVANCES.DESCARGAR' | translate}}" (click)="btnDescargar()" style="padding-right: 5px!important;">
                            {{'AVANCES.DESCARGAR' | translate}}
                            <mat-icon>cloud_download</mat-icon>
                          </button>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start start" style="padding-right: 5px;">
                          <a mat-raised-button color="primary" matTooltip="{{'AVANCES.GOSURVEY' | translate}}" href="{{urlEncuesta}}" target="_blank" *ngIf="showUrl" style="padding-left: 5px!important;">
                            {{'AVANCES.GOSURVEY' | translate}}
                            <mat-icon ahref="/link/to/page2">assessment</mat-icon>
                          </a>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start start">
                          <button mat-raised-button class="mb-20" color="primary" matTooltip="{{'AVANCES.PRIMEROS' | translate}}" (click)="show1000()" style="padding-right: 5px!important;">
                            {{'AVANCES.PRIMEROS' | translate}}
                            <mat-icon>supervisor_account</mat-icon>
                          </button>
                        </div>
                      </div>

                      <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="mostrarTabla" style="width: 100%; padding-left: 20px;">
                        <br>
                        <table mat-table [dataSource]="dataSource_nuevo" class="mat-elevation-z8">

                          <!--- Note that these columns can be defined in any order.
                          The actual rendered columns are set as a property on the row definition" -->

                          <!-- Position Column -->
                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> {{'AVANCES.ENCUESTA.LABEL01' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                              <p>{{element.name}}</p>
                            </td>
                          </ng-container>

                          <!-- Name Column -->
                          <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef> {{'AVANCES.ENCUESTA.LABEL02' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                              <p>{{element.email}}</p>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="copy">
                            <th mat-header-cell *matHeaderCellDef class="header_table"> {{'AVANCES.ENCUESTA.LABEL12' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="align-content: center;">
                              <!--(click)="send_email(element.email,1)"-->
                              <button mat-mini-fab color="primary" matTooltip="{{'AVANCES.ENCUESTA.LABEL12' | translate}}" (click)="copyMessage(element.password)">
                                <mat-icon>file_copy</mat-icon>
                              </button>
                              <p>{{element.password}}</p>
                            </td>
                          </ng-container>

                          <!-- Weight Column -->
                          <ng-container matColumnDef="surveyid">
                            <th mat-header-cell *matHeaderCellDef> {{'AVANCES.ENCUESTA.LABEL04' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                              <p *ngIf="element.id_status == 1"> {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO1' | translate}} </p>
                              <p *ngIf="element.id_status == 2"> {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO2' | translate}} </p>
                              <p *ngIf="element.id_status == 3"> {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO3' | translate}} </p>
                              <p *ngIf="element.id_status == 4"> {{'AVANCES.TITULOS.ESTADOS_ENC.ESTADO4' | translate}} </p>
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> {{'AVANCES.ENCUESTA.LABEL08' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                              <span class="text-muted" *ngIf="element.start_date != null "> {{element.start_date | date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{element.start_date |date:'O':offsetPipe:idiomaActual}}) <!--{{ element.start_date}}--> </span>

                              <span class="text-muted" *ngIf="element.start_date == null ">{{ 'AVANCES.ENCUESTA.NA' | translate}} </span>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="fecha">
                            <th mat-header-cell *matHeaderCellDef> {{'AVANCES.ENCUESTA.LABEL09' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                              <span class="text-muted" *ngIf="element.end_date != null ">{{element.end_date | date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{element.end_date |date:'O':offsetPipe:idiomaActual}}) </span>

                              <span class="text-muted" *ngIf="element.end_date == null ">{{ 'AVANCES.ENCUESTA.NA' | translate}}</span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="accion">
                            <th mat-header-cell *matHeaderCellDef> {{'AVANCES.NEWCOLAB.ACCIONES' | translate}} </th>
                            <td mat-cell *matCellDef="let element">

                              <button mat-mini-fab color="primary" matTooltip="{{'AVANCES.NEWCOLAB.VERACT' | translate}}" (click)="openDialogAcciones(element)">
                                <mat-icon>account_circle</mat-icon>
                              </button>
                              <!--<ng-container *ngIf="element.id_status != 4">
                              <button mat-mini-fab color="primary" matTooltip="{{'AVANCES.ENCUESTA.LABEL11' | translate}}" (click)="openDialogAccionesEmail(element.email,element.name,1,1)" [disabled]="disableButton">
                              <mat-icon>assignment</mat-icon>
                            </button>
                          </ng-container>-->

                          <button mat-mini-fab color="primary" matTooltip="{{'AVANCES.ENCUESTA.LABEL11' | translate}}" (click)="openDialogAccionesEmail(element.email,element.name,1,1,element.id_status)">
                            <mat-icon>assignment</mat-icon>
                          </button>


                        </td>
                      </ng-container>
                      <!--<ng-container matColumnDef="inv">
                      <th mat-header-cell *matHeaderCellDef class="header_table"> {{'AVANCES.ENCUESTA.LABEL11' | translate}} </th>
                      <td mat-cell *matCellDef="let element" style="align-content: center;">

                      <ng-container *ngIf="element.id_status != 4">
                      <button mat-mini-fab color="primary" matTooltip="{{'AVANCES.ENCUESTA.LABEL11' | translate}}" (click)="openDialogAccionesEmail(element.email,element.name,1,1)" [disabled]="disableButton">
                      <mat-icon>assignment</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="element.id_status == 4">
                  <button mat-mini-fab color="primary" matTooltip="{{'AVANCES.ENCUESTA.LABEL11' | translate}}" (click)="openDialogAccionesEmail(element.email,element.name,1,1)" [disabled]="bloqueTotal">
                  <mat-icon>assignment</mat-icon>
                </button>
              </ng-container>

            </td>
          </ng-container>-->


          <!--<ng-container matColumnDef="recor">
          <th mat-header-cell *matHeaderCellDef class="header_table"> {{'AVANCES.ENCUESTA.LABEL06' | translate}} </th>
          <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="black" aria-label="Example icon button with a heart icon" (click)="send_email(element.email,2)" matTooltip="{{'AVANCES.ENCUESTA.LABEL06' | translate}}" [disabled]="disableButton">
          <mat-icon>mark_email_unread</mat-icon>
        </button>
      </td>
    </ng-container>-->

    <tr mat-header-row *matHeaderRowDef="nombresColumnasheader"></tr>
    <tr mat-row *matRowDef="let row; columns: nombresColumnasCont;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[15, 30, 50, 80]" showFirstLastButtons></mat-paginator>
  <!--<mat-paginator [pageSizeOptions]="[10, 25, 100, 500]" showFirstLastButtons style="margin-bottom: 250px;"></mat-paginator>-->

  <!--<button type="button" mat-button (click)="drawer.toggle()">
  Toggle sidenav
</button>-->

<div class="mat-elevation-z4 pr-20 pl-20" fxLayout="row" style="padding-top: 20px; " fxLayoutAlign="center center" *ngIf="Nousers">
  <h2>{{'AVANCES.ENCUESTA.NOUSER' | translate}}</h2>
  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
</div>
</div>

</ng-container>

</div>
</ng-container>


</div>
</mat-sidenav-content>
</mat-sidenav-container>
</div>
<!-- / CONTENT -->
</div>
</div>
</div>
